import React, { useContext } from "react";
import useWebInstallPrompt from "./useWebInstallPrompt";
import { MDBAlert } from "mdb-react-ui-kit";
import { ThemeContext } from "../Context/ThemeContext.js";

function InstallPWAAndroid() {
    const [isVisible, setVisibleState] = React.useState(false);
    const { appliedTheme } = useContext(ThemeContext);
    const [webInstallPrompt, handleWebInstallDeclined, handleWebInstallAccepted] = useWebInstallPrompt();
    let themeClass = ( appliedTheme === "dark" || appliedTheme === "high-contrast") ? "bg-dark text-white" : "";
    const hide = () => setVisibleState(false);

    React.useEffect(() => {
        if (webInstallPrompt) {
            setVisibleState(true);
        }
    }, [webInstallPrompt]);

    if (!webInstallPrompt) {
        return null; // Return null or an empty div if webInstallPrompt is falsy
    }

    return (
        <div  onClick={hide} style={{ background: 'red' }}>
            <MDBAlert
                color='secondary'
                autohide={false}
                position='top-center'
                
                delay={2000}
                appendToBody
                open={isVisible}
                onClose={() => setVisibleState(false)}
                className={`prompt-banner text-center w-100 pwa-prompt ${themeClass}`} // Adding Bootstrap utility classes
                style={{ maxWidth: '100%' }} // Adjusting max width as needed
            >
                <p className="mb-0">
                    This website has app functionality.{' '}
                    <a href="#" onClick={handleWebInstallAccepted}>
                        Add it to your home screen
                    </a>{' '}
                    to use it in fullscreen.
                    <button
                        type="button"
                        title="Close"
                        className="btn-close"
                        onClick={handleWebInstallDeclined}
                    ></button>
                </p>
            </MDBAlert>
        </div>
    );
}

export default InstallPWAAndroid;
